export default {
    entityKey: 'pipeline-templates',
    titles: {
        singular: 'Pipeline Template',
        plural: 'Pipeline Templates'
    }
}
